export default "__VITE_ASSET__CL4p5w40__"